export default {
    'version.name.duplicate.error': 'Version with the same name already exists for this package',
    'version.name.blank': 'Version name is mandatory',
    'version.snapshot.error': 'Snapshot versions are not supported.',
    'version.name.dots.invalid': 'Version name can"t have two dots in a row.',
    'version.name.pattern.error': 'Version name must start with a letter or a number and can only contain letters, numbers and the following symbols: .-_:#@$~',
    'default.invalid.url.message': 'Please enter a valid VCS URL for your OSS package.',
    'repo.name.matches.error': 'Name must start with a letter or a digit and can only contain letters, digits and dashes',
    'repo.name.matches.docker.error': 'Name must start with a lowercase letter or a digit and can only contain lowercase letters, digits and dashes',
    'repo.name.unique': 'Repository key already exist',
    'repo.link.failed': 'Could not link repository "@{0}" to repository "@{1}"',
    'repo.unlink.failed': 'Could not un-link repository "@{0}" from repository "@{1}"',
    'repo.link.no.target': 'Please select a valid target repository to link to',
    'name.part.forbidden': 'Name cannot contain ‘@{0}‘. Please try another one.',
    'integer': 'Folder depth must be an integer',
}
;




// WEBPACK FOOTER //
// ./modules/distribution/constants/error.messages.constants.js